import { useCreateOrUpdateArtworkInBibliography } from "@/api/related-fields";
import { LinkableType } from "@/components/LinksManagement";
import { FieldConfig } from "@/config/forms/general";
import { ArtworkInBibliography } from "@/lib/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import LinksDrawerLayout from "./LinksDrawerLayout";

const ArtworkInBibliographyDrawer = ({
  fields,
  data,
  queryId,
  type,
}: {
  fields: FieldConfig[] | undefined;
  data: ArtworkInBibliography;
  queryId: string;
  type: LinkableType;
}) => {
  const schema = z.object({
    oeuvresDansBibliographieDescriptionReproduitPage: z.string().optional(),
    oeuvresDansBibliographieDescriptionCitePage: z.string().optional(),
    oeuvresDansBibliographieDescriptionPhotographe: z.string().optional(),
    oeuvresDansBibliographieDescriptionReproductionCouleur: z
      .boolean()
      .optional(),
    oeuvresDansBibliographieDescriptionNonPagine: z.boolean().optional(),
    oeuvresDansBibliographieNotes: z.string().optional(),
    bibliography: z.object({
      bibliographieDescriptionNumeroBibliographie: z.string().optional(),
      bibliographieDescriptionResumeLong: z.string().optional(),
    }),
  });

  const { mutate: createOrUpdateArtworkInBibliography } =
    useCreateOrUpdateArtworkInBibliography(queryId, type);

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: {
      bibliography: data.bibliography,
      oeuvresDansBibliographieDescriptionReproduitPage:
        data.oeuvresDansBibliographieDescriptionReproduitPage,
      oeuvresDansBibliographieDescriptionCitePage:
        data.oeuvresDansBibliographieDescriptionCitePage,
      oeuvresDansBibliographieDescriptionPhotographe:
        data.oeuvresDansBibliographieDescriptionPhotographe,
      oeuvresDansBibliographieDescriptionReproductionCouleur:
        data.oeuvresDansBibliographieDescriptionReproductionCouleur,
      oeuvresDansBibliographieDescriptionNonPagine:
        data.oeuvresDansBibliographieDescriptionNonPagine,
      oeuvresDansBibliographieNotes: data.oeuvresDansBibliographieNotes,
    },
  });

  const onSubmit = (formData: z.infer<typeof schema>) => {
    createOrUpdateArtworkInBibliography({
      id: data.id,
      artworkId: data.artwork.id,
      bibliographyId: data.bibliography.id,
      ...formData,
    });
  };

  return (
    <LinksDrawerLayout
      form={form}
      fields={fields ?? []}
      recordId={data.id}
      onSubmit={onSubmit}
    />
  );
};

export default ArtworkInBibliographyDrawer;
